import {useInfiniteQuery} from '@tanstack/react-query';
import {getHistory} from '../services/chatMessages';


export const useMessagesQuery = (trip_id: string) => {
    return useInfiniteQuery({
        refetchOnWindowFocus: false,
        queryKey: ['chatHistory', trip_id],
        queryFn: ({pageParam = null}) => getHistory(parseInt(trip_id!), pageParam),
        initialPageParam: '',
        getNextPageParam: (lastPage, allPages) => {
            return lastPage.next ? lastPage.next : undefined
        }
    })
}